import React from 'react';
import {Notification} from '../navigation/page-layout';
import {HiFoExplainer} from './hifo-explainer';
import {useTenantConfiguration} from '../hooks/use-tenant-configuration';
import {LgbmExplainer} from './lgbm-explainer';
import {Header} from '@amzn/awsui-components-react';
import {BoscoExplainer} from './bosco-explainer';
import {FoundationExplainer} from './foundation-explainer';

export default function ViewInsights(props: {pushNotification: (notification: Notification) => void}) {
    const {configurationData, isLoading} = useTenantConfiguration();

    if (isLoading || !configurationData) {
        return <React.Fragment></React.Fragment>;
    }

    if (!configurationData.modelName) {
        return <React.Fragment></React.Fragment>;
    }

    const componenyByModelName = {
        hifo: <HiFoExplainer pushNotification={props.pushNotification} configurationData={configurationData}></HiFoExplainer>,
        lgbm: <LgbmExplainer pushNotification={props.pushNotification} configurationData={configurationData}></LgbmExplainer>,
        bosco: <BoscoExplainer pushNotification={props.pushNotification}></BoscoExplainer>,
        foundation: <FoundationExplainer pushNotification={props.pushNotification}></FoundationExplainer>,
    };

    return (
        <React.Fragment>
            <div className="main-content">
                <Header variant="h1">{`Insights - ${configurationData.modelName.toUpperCase()}`}</Header>
                {componenyByModelName[configurationData.modelName]}
            </div>
        </React.Fragment>
    );
}
